export const mismatchedPageView =  {
    event: "mismatched_page_view"
};
export const mismatchedOptionSelection =  {
    event: "mismatched_option_selection"
};
